import { ACCESS_LOGS_LIST_CONFIG } from '../configs/access_logs.config';
import { AUTOMATION_REPORTS_BATCH_EMBEDDED_CONFIG } from '../configs/automation-reports-batch-embedded.config';
import { AUTOMATION_REPORTS_TRIGGER_EMBEDDED_CONFIG } from '../configs/automation-reports-trigger-embedded.config';
import { AUTOMATION_TARGET_LISTS_EMBEDDED_CONFIG } from '../configs/automation-target-lists-embedded.config';
import { AUTOMATION_BATCHES_CONFIG } from '../configs/automation_batches.config';
import { AUTOMATION_FLOWS_LIST_CONFIG } from '../configs/automation_flows.config';
import { AUTOMATION_REPORTS_CONFIG } from '../configs/automation_reports.config';
import { AUTOMATION_TARGET_LISTS_CONFIG } from '../configs/automation_target_lists.config';
import { AUTOMATION_TRIGGERS_CONFIG } from '../configs/automation_triggers.config';
import { CALL_HISTORY_CLIENT_EMBEDDED_CONFIG } from '../configs/call-history-client-embedded.config';
import { CALL_HISTORY_LIST_CONFIG } from '../configs/call_history.config';
import { CLIENT_CONFIG } from '../configs/client';
import { CLIENT_CHILDREN_EMBEDDED_CONFIG } from '../configs/client-children-embedded.config';
import { CLIENT_CONTACTS_EMBEDDED_CONFIG } from '../configs/client-contacts-embedded.config';
import { CLIENT_EMAILS_EMBEDDED_CONFIG } from '../configs/client-emails-embedded.config';
import { CLIENT_FILES_EMBEDDED_CONFIG } from '../configs/client-files-embedded.config';
import { CLIENT_ITEM_HISTORY_CONFIG } from '../configs/client-item-history';
import { CLIENT_OWNERSHIP_EMBEDDED_CONFIG } from '../configs/client-ownership-embedded.config';
import { CLIENT_SHOP_CONFIG } from '../configs/client-shop';
import { CLIENT_ECOMMERCE_USER_LIST_CONFIG } from '../configs/client_ecommerce_user.config';
import { CLIENT_LICENSES_LIST_CONFIG } from '../configs/client_licenses.config';
import { CLIENT_LIST_CONFIG } from '../configs/client_list.config';
import { CLIENT_LIST_CLIENTS_CONFIG } from '../configs/client_list_clients.config';
import { CLIENT_LOCATION_CONFIG } from '../configs/client_location.config';
import { CLIENT_NOTES_LIST_CONFIG } from '../configs/client_notes.config';
import { CLIENT_TRIP_HISTORY_LIST_CONFIG } from '../configs/client_trip_history.config';
import { CLIENT_VISITS_LIST_CONFIG } from '../configs/client_visits.config';
import { CLIENT_CATEGORY_INSIGHTS_CONFIG } from '../configs/clientCategoryInsights.config';
import { COMPETITIVE_PRICE_CLIENT_EMBEDDED_CONFIG } from '../configs/competitive-price-client-embedded.config';
import { COMPETITIVE_PRICE_ITEM_EMBEDDED_CONFIG } from '../configs/competitive-price-item-embedded.config';
import { CONVERSATION_AGENT_EMBEDDED_CONFIG } from '../configs/conversation-agent-embedded.config';
import { CONVERSATION_AGENT_CONFIG } from '../configs/conversation_agent.config';
import { CONVERSATION_ANALYZER_CONFIG } from '../configs/conversation_analyzer.config';
import { CONVERSATION_SESSION_CONFIG } from '../configs/conversation_session.config';
import { CONVERSATION_TOOL_CONFIG } from '../configs/conversation_tool.config';
import { CONVERSATION_VOICE_PROFILE_CONFIG } from '../configs/conversation_voice_profile.config';
import { DRIVER_LIST_CONFIG } from '../configs/driver.config';
import { ECOMMERCE_USER_LIST_CONFIG } from '../configs/ecommerce_user.config';
import { ECOMMERCE_USER_CLIENTS_LIST_CONFIG } from '../configs/ecommerce_user_clients.config';
import { EMAIL_TEMPLATES_LIST_CONFIG } from '../configs/email_templates.config';
import { GROUP_USERS_LIST_CONFIG } from '../configs/group-users.config';
import { GROUP_LIST_CONFIG } from '../configs/group.config';
import { INVOICE_LIST_CONFIG } from '../configs/invoice';
import { INVOICE_CLIENT_EMBEDDED_CONFIG } from '../configs/invoice-client-embedded.config';
import { INVOICE_ORDER_EMBEDDED_CONFIG } from '../configs/invoice-order-embedded.config';
import { INVOICE_DETAIL_LIST_CONFIG } from '../configs/invoice_detail.config';
import { ISSUE_CLIENT_EMBEDDED_CONFIG } from '../configs/issue-client-embedded.config';
import { ISSUE_FILES_EMBEDDED_CONFIG } from '../configs/issue-files-embedded.config';
import { ISSUE_LINK_EMBEDDED_CONFIG } from '../configs/issue-link-embedded.config';
import { ISSUE_MERCHANDISER_EMBEDDED_CONFIG } from '../configs/issue-merchandiser-embedded.config';
import { ISSUE_SOURCING_REQUEST_EMBEDDED_CONFIG } from '../configs/issue-sourcing-request-embedded.config';
import { ISSUE_VEHICLE_EMBEDDED_CONFIG } from '../configs/issue-vehicle-embedded.config';
import { ISSUE_VENDOR_EMBEDDED_CONFIG } from '../configs/issue-vendor-embedded.config';
import { ISSUE_LIST_CONFIG } from '../configs/issue.config';
import { ISSUE_NOTES_LIST_CONFIG } from '../configs/issue_notes.config';
import { ITEM_FILES_EMBEDDED_CONFIG } from '../configs/item-files-embedded.config';
import { ITEM_PURCHASED_TOGETHER_EMBEDDED_CONFIG } from '../configs/item-purchased-together-embedded.config';
import { ITEM_WAREHOUSE_EMBEDDED_CONFIG } from '../configs/item-warehouse-embedded.config';
import { ITEM_LIST_CONFIG } from '../configs/item.config';
import { ITEM_CLIENT_HISTORY_CONFIG } from '../configs/itemClientHistory.config';
import { ITEM_LOT_ITEM_EMBEDDED_CONFIG } from '../configs/itemLot-item-embedded.config';
import { ITEM_LOT_LOCATION_EMBEDDED_CONFIG } from '../configs/itemLot-location-embedded.config';
import { ITEM_LOT_WAREHOUSE_EMBEDDED_CONFIG } from '../configs/itemLot-warehouse-embedded.config';
import { ITEM_WAREHOUSE_ITEM_EMBEDDED_CONFIG } from '../configs/itemWarehouse-item-embedded.config';
import { LEAD_ELIGIBILITY_LIST_CONFIG } from '../configs/lead-eligibility.config';
import { LICENSE_LIST_CONFIG } from '../configs/license';
import { LICENSE_AUDIT_EMBEDDED_CONFIG } from '../configs/license-audit-embedded.config';
import { LICENSE_DISCIPLINARY_EMBEDDED_CONFIG } from '../configs/license-disciplinary-embedded.config';
import { LICENSE_DISCREPANCIES_EMBEDDED_CONFIG } from '../configs/license-discrepancies-embedded.config';
import { LICENSE_FILES_EMBEDDED_CONFIG } from '../configs/license-files-embedded.config';
import { LICENSE_LINKS_EMBEDDED_CONFIG } from '../configs/license-links-embedded.config';
import { LICENSE_MATCH_LIST_CONFIG } from '../configs/license_match.config';
import { LICENSE_NOTES_LIST_CONFIG } from '../configs/license_notes.config';
import { LOCATION_LIST_CONFIG } from '../configs/location';
import { LOCATION_ITEM_LIST_CONFIG } from '../configs/locationItem.config';
import { LOGIN_HISTORY_LIST_CONFIG } from '../configs/login_history.config';
import { MERCHANDISER_LIST_CONFIG } from '../configs/merchandiser';
import { MESSAGING_TEMPLATES_LIST_CONFIG } from '../configs/messaging_templates.config';
import { OPPORTUNITY_CLIENT_EMBEDDED_CONFIG } from '../configs/opportunity-client-embedded.config';
import { OPPORTUNITY_FILES_EMBEDDED_CONFIG } from '../configs/opportunity-files-embedded.config';
import { OPPORTUNITY_LIST_CONFIG } from '../configs/opportunity.config';
import { OPPORTUNITY_NOTES_LIST_CONFIG } from '../configs/opportunity_notes.config';
import { ORDER_CONFIG } from '../configs/order';
import { ORDER_CLIENT_EMBEDDED_CONFIG } from '../configs/order-client-embedded';
import { ORDER_INVOICE_EMBEDDED_CONFIG } from '../configs/order-invoice-embedded.config';
import { ORDER_DETAIL_LIST_CONFIG } from '../configs/order_detail.config';
import { OWNERSHIP_CONFIG } from '../configs/ownership.config';
import { OWNERSHIP_CLIENT_LIST_CONFIG } from '../configs/ownership_client.config';
import { PAYMENT_METHODS_LIST_CONFIG } from '../configs/payment_methods.config';
import { PAYMENT_SCHEDULE_OCCURRENCES_LIST_CONFIG } from '../configs/payment_schedule_occurrences.config';
import { PAYMENT_SCHEDULES_LIST_CONFIG } from '../configs/payment_schedules.config';
import { PRICE_CONTRACT_CLIENT_EMBEDDED_CONFIG } from '../configs/price-contract-client-embedded.config';
import { PRICE_CONTRACT_ITEM_EMBEDDED_CONFIG } from '../configs/price-contract-item-embedded.config';
import { PRICE_CONTRACT_LIST_CONFIG } from '../configs/price_contract.config';
import { PRICE_CONTRACT_CLIENT_LIST_CONFIG } from '../configs/price_contract_client.config';
import { PRICE_CONTRACT_ITEM_LIST_CONFIG } from '../configs/price_contract_item.config';
import { PROMO_LIST_CONFIG } from '../configs/promo.config';
import { PURCHASE_ORDER_VENDOR_EMBEDDED_CONFIG } from '../configs/purchase-order-vendor-embedded.config';
import { PURCHASE_ORDER_LIST_CONFIG } from '../configs/purchase_order.config';
import { PURCHASE_ORDER_DETAIL_LIST_CONFIG } from '../configs/purchase_order_detail.config';
import { PURCHASE_ORDER_RECEIPT_LIST_CONFIG } from '../configs/purchase_order_receipt.config';
import { PURCHASE_ORDER_RECEIPTS_MAIN_LIST_CONFIG } from '../configs/purchase_order_receipts_main.config';
import { PURCHASE_ORDER_RECEIPTS_VENDOR_EMBEDDED_CONFIG } from '../configs/purchase_order_receipts_vendor_embedded.config';
import { QUOTE_CLIENT_EMBEDDED_CONFIG } from '../configs/quote-client-embedded.config';
import { QUOTE_SHOP_CONFIG } from '../configs/quote-shop';
import { QUOTE_LIST_CONFIG } from '../configs/quote.config';
import { REGISTRY_LIST_CONFIG } from '../configs/registry';
import { ROUTE_LIST_CONFIG } from '../configs/route.config';
import { SENSOR_DEVICE_LIST_CONFIG } from '../configs/sensorDevice';
import { SENSOR_READING_SENSOR_EMBEDDED_CONFIG } from '../configs/sensorReading-sensor-embedded.config';
import { SOURCING_REQUEST_LIST_CONFIG } from '../configs/sourcing-request';
import { SOURCING_REQUEST_CLIENT_EMBEDDED_CONFIG } from '../configs/sourcing-request-client-embedded.config';
import { SOURCING_REQUEST_FILES_EMBEDDED_CONFIG } from '../configs/sourcing-request-files-embedded.config';
import { SOURCING_REQUEST_ITEM_EMBEDDED_CONFIG } from '../configs/sourcing-request-item-embedded.config';
import { SOURCING_REQUEST_VENDOR_EMBEDDED_CONFIG } from '../configs/sourcing-request-vendor-embedded.config';
import { SOURCING_REQUEST_NOTES_LIST_CONFIG } from '../configs/sourcing_request_notes.config';
import { STATEMENT_CLIENT_EMBEDDED_CONFIG } from '../configs/statement-client-embedded.config';
import { STATEMENT_LIST_CONFIG } from '../configs/statement.config';
import { SYSTEM_SENT_EMAILS_CONFIG } from '../configs/system_sent_emails.config';
import { TASK_LIST_CONFIG } from '../configs/task';
import { TASK_CALENDAR_MODAL_CONFIG } from '../configs/task-calendar-modal.config';
import { TASK_CLIENT_EMBEDDED_CONFIG } from '../configs/task-client-embedded.config';
import { TASK_ISSUE_EMBEDDED_CONFIG } from '../configs/task-issue-embedded.config';
import { TASK_LICENSE_EMBEDDED_CONFIG } from '../configs/task-license-embedded.config';
import { TASK_OPPORTUNITY_EMBEDDED_CONFIG } from '../configs/task-opportunity-embedded.config';
import { TASK_SOURCING_REQUEST_EMBEDDED_CONFIG } from '../configs/task-sourcing-request-embedded.config';
import { TEAM_LIST_CONFIG } from '../configs/team.config';
import { TRANSACTION_CLIENT_EMBEDDED_CONFIG } from '../configs/transaction-client-embedded.config';
import { TRANSACTION_INVOICE_EMBEDDED_CONFIG } from '../configs/transaction-invoice-embedded.config';
import { TRANSACTION_ORDER_EMBEDDED_CONFIG } from '../configs/transaction-order-embedded.config';
import { TRANSACTION_SUMMARY_LIST_CONFIG } from '../configs/transaction-summary';
import { TRIP_LIST_CONFIG } from '../configs/trip';
import { VEHICLE_LIST_CONFIG } from '../configs/vehicle';
import { VENDOR_LIST_CONFIG } from '../configs/vendor.config';
import { VENDOR_ITEM_LIST_CONFIG } from '../configs/vendor_item.config';
import { WAREHOUSE_LIST_CONFIG } from '../configs/warehouse.config';
import invoiceShopDefaults from './invoice_shop.json';

export const listBuilderDefaults = {
	call_history: CALL_HISTORY_LIST_CONFIG,
	client: CLIENT_CONFIG,
	clientItemHistory: CLIENT_ITEM_HISTORY_CONFIG,
	client_list: CLIENT_LIST_CONFIG,
	client_list_clients: CLIENT_LIST_CLIENTS_CONFIG,
	'client-children-embedded': CLIENT_CHILDREN_EMBEDDED_CONFIG,
	'client-ownership-embedded': CLIENT_OWNERSHIP_EMBEDDED_CONFIG,
	clientCategoryInsights: CLIENT_CATEGORY_INSIGHTS_CONFIG,
	client_licenses: CLIENT_LICENSES_LIST_CONFIG,
	itemClientHistory: ITEM_CLIENT_HISTORY_CONFIG,
	client_shop: CLIENT_SHOP_CONFIG,
	conversation_agent: CONVERSATION_AGENT_CONFIG,
	conversation_analyzer: CONVERSATION_ANALYZER_CONFIG,
	conversation_session: CONVERSATION_SESSION_CONFIG,
	conversation_tool: CONVERSATION_TOOL_CONFIG,
	conversation_voice_profile: CONVERSATION_VOICE_PROFILE_CONFIG,
	invoice: INVOICE_LIST_CONFIG,
	invoice_detail: INVOICE_DETAIL_LIST_CONFIG,
	invoice_shop: invoiceShopDefaults,
	issue: ISSUE_LIST_CONFIG,
	license: LICENSE_LIST_CONFIG,
	license_match: LICENSE_MATCH_LIST_CONFIG,
	item: ITEM_LIST_CONFIG,
	order: ORDER_CONFIG,
	order_detail: ORDER_DETAIL_LIST_CONFIG,
	purchase_order: PURCHASE_ORDER_LIST_CONFIG,
	purchase_order_detail: PURCHASE_ORDER_DETAIL_LIST_CONFIG,
	purchase_order_receipt: PURCHASE_ORDER_RECEIPT_LIST_CONFIG,
	purchase_order_receipts_main: PURCHASE_ORDER_RECEIPTS_MAIN_LIST_CONFIG,
	purchase_order_receipts_vendor_embedded:
		PURCHASE_ORDER_RECEIPTS_VENDOR_EMBEDDED_CONFIG,
	quote_shop: QUOTE_SHOP_CONFIG,
	quote: QUOTE_LIST_CONFIG,
	registry: REGISTRY_LIST_CONFIG,
	transaction_summary: TRANSACTION_SUMMARY_LIST_CONFIG,
	vendor: VENDOR_LIST_CONFIG,
	vendor_item: VENDOR_ITEM_LIST_CONFIG,
	warehouse: WAREHOUSE_LIST_CONFIG,
	automation_flows: AUTOMATION_FLOWS_LIST_CONFIG,
	automation_batches: AUTOMATION_BATCHES_CONFIG,
	automation_target_lists: AUTOMATION_TARGET_LISTS_CONFIG,
	automation_triggers: AUTOMATION_TRIGGERS_CONFIG,
	automation_reports: AUTOMATION_REPORTS_CONFIG,
	task: TASK_LIST_CONFIG,
	team: TEAM_LIST_CONFIG,
	lead_eligibility: LEAD_ELIGIBILITY_LIST_CONFIG,
	promo: PROMO_LIST_CONFIG,
	opportunity: OPPORTUNITY_LIST_CONFIG,
	opportunity_notes: OPPORTUNITY_NOTES_LIST_CONFIG,
	email_templates: EMAIL_TEMPLATES_LIST_CONFIG,
	messaging_templates: MESSAGING_TEMPLATES_LIST_CONFIG,
	system_sent_emails: SYSTEM_SENT_EMAILS_CONFIG,
	access_logs: ACCESS_LOGS_LIST_CONFIG,
	login_history: LOGIN_HISTORY_LIST_CONFIG,
	payment_methods: PAYMENT_METHODS_LIST_CONFIG,
	payment_schedule_occurrences: PAYMENT_SCHEDULE_OCCURRENCES_LIST_CONFIG,
	payment_schedules: PAYMENT_SCHEDULES_LIST_CONFIG,
	price_contract: PRICE_CONTRACT_LIST_CONFIG,
	price_contract_item: PRICE_CONTRACT_ITEM_LIST_CONFIG,
	price_contract_client: PRICE_CONTRACT_CLIENT_LIST_CONFIG,
	ownership_client: OWNERSHIP_CLIENT_LIST_CONFIG,
	group: GROUP_LIST_CONFIG,
	'group-users': GROUP_USERS_LIST_CONFIG,
	location: LOCATION_LIST_CONFIG,
	locationItem: LOCATION_ITEM_LIST_CONFIG,
	trip: TRIP_LIST_CONFIG,
	route: ROUTE_LIST_CONFIG,
	sourcing_request: SOURCING_REQUEST_LIST_CONFIG,
	statement: STATEMENT_LIST_CONFIG,
	'statement-client-embedded': STATEMENT_CLIENT_EMBEDDED_CONFIG,
	sourcing_request_notes: SOURCING_REQUEST_NOTES_LIST_CONFIG,
	driver: DRIVER_LIST_CONFIG,
	vehicle: VEHICLE_LIST_CONFIG,
	merchandiser: MERCHANDISER_LIST_CONFIG,
	sensor_device: SENSOR_DEVICE_LIST_CONFIG,
	client_trip_history: CLIENT_TRIP_HISTORY_LIST_CONFIG,
	client_visits: CLIENT_VISITS_LIST_CONFIG,
	client_notes: CLIENT_NOTES_LIST_CONFIG,
	ecommerce_user: ECOMMERCE_USER_LIST_CONFIG,
	ecommerce_user_clients: ECOMMERCE_USER_CLIENTS_LIST_CONFIG,
	client_ecommerce_user: CLIENT_ECOMMERCE_USER_LIST_CONFIG,
	'client-files-embedded': CLIENT_FILES_EMBEDDED_CONFIG,
	'client-contacts-embedded': CLIENT_CONTACTS_EMBEDDED_CONFIG,
	client_location: CLIENT_LOCATION_CONFIG,
	ownership: OWNERSHIP_CONFIG,
	'opportunity-client-embedded': OPPORTUNITY_CLIENT_EMBEDDED_CONFIG,
	'transaction-client-embedded': TRANSACTION_CLIENT_EMBEDDED_CONFIG,
	'transaction-invoice-embedded': TRANSACTION_INVOICE_EMBEDDED_CONFIG,
	'transaction-order-embedded': TRANSACTION_ORDER_EMBEDDED_CONFIG,
	'quote-client-embedded': QUOTE_CLIENT_EMBEDDED_CONFIG,
	'invoice-client-embedded': INVOICE_CLIENT_EMBEDDED_CONFIG,
	'invoice-order-embedded': INVOICE_ORDER_EMBEDDED_CONFIG,
	'conversation-agent-embedded': CONVERSATION_AGENT_EMBEDDED_CONFIG,
	'call-history-client-embedded': CALL_HISTORY_CLIENT_EMBEDDED_CONFIG,
	'client-emails-embedded': CLIENT_EMAILS_EMBEDDED_CONFIG,
	'order-client-embedded': ORDER_CLIENT_EMBEDDED_CONFIG,
	'order-invoice-embedded': ORDER_INVOICE_EMBEDDED_CONFIG,
	'item-warehouse-embedded': ITEM_WAREHOUSE_EMBEDDED_CONFIG,
	'itemWarehouse-item-embedded': ITEM_WAREHOUSE_ITEM_EMBEDDED_CONFIG,
	'item-purchased-together-embedded': ITEM_PURCHASED_TOGETHER_EMBEDDED_CONFIG,
	'itemLot-item-embedded': ITEM_LOT_ITEM_EMBEDDED_CONFIG,
	'sensorReading-sensor-embedded': SENSOR_READING_SENSOR_EMBEDDED_CONFIG,
	'itemLot-location-embedded': ITEM_LOT_LOCATION_EMBEDDED_CONFIG,
	'itemLot-warehouse-embedded': ITEM_LOT_WAREHOUSE_EMBEDDED_CONFIG,
	'issue-vendor-embedded': ISSUE_VENDOR_EMBEDDED_CONFIG,
	'issue-vehicle-embedded': ISSUE_VEHICLE_EMBEDDED_CONFIG,
	'issue-merchandiser-embedded': ISSUE_MERCHANDISER_EMBEDDED_CONFIG,
	'issue-client-embedded': ISSUE_CLIENT_EMBEDDED_CONFIG,
	'item-files-embedded': ITEM_FILES_EMBEDDED_CONFIG,
	'issue-files-embedded': ISSUE_FILES_EMBEDDED_CONFIG,
	'issue-link-embedded': ISSUE_LINK_EMBEDDED_CONFIG,
	issue_notes: ISSUE_NOTES_LIST_CONFIG,
	'issue-sourcing-request-embedded': ISSUE_SOURCING_REQUEST_EMBEDDED_CONFIG,
	'license-audit-embedded': LICENSE_AUDIT_EMBEDDED_CONFIG,
	'license-disciplinary-embedded': LICENSE_DISCIPLINARY_EMBEDDED_CONFIG,
	'license-discrepancies-embedded': LICENSE_DISCREPANCIES_EMBEDDED_CONFIG,
	'license-files-embedded': LICENSE_FILES_EMBEDDED_CONFIG,
	'license-links-embedded': LICENSE_LINKS_EMBEDDED_CONFIG,
	license_notes: LICENSE_NOTES_LIST_CONFIG,
	'opportunity-files-embedded': OPPORTUNITY_FILES_EMBEDDED_CONFIG,
	'sourcing-request-files-embedded': SOURCING_REQUEST_FILES_EMBEDDED_CONFIG,
	'sourcing-request-client-embedded': SOURCING_REQUEST_CLIENT_EMBEDDED_CONFIG,
	'sourcing-request-vendor-embedded': SOURCING_REQUEST_VENDOR_EMBEDDED_CONFIG,
	'sourcing-request-item-embedded': SOURCING_REQUEST_ITEM_EMBEDDED_CONFIG,
	'purchase-order-vendor-embedded': PURCHASE_ORDER_VENDOR_EMBEDDED_CONFIG,
	'automation-reports-batch-embedded': AUTOMATION_REPORTS_BATCH_EMBEDDED_CONFIG,
	'automation-reports-trigger-embedded':
		AUTOMATION_REPORTS_TRIGGER_EMBEDDED_CONFIG,
	'task-calendar-modal': TASK_CALENDAR_MODAL_CONFIG,
	'task-client-embedded': TASK_CLIENT_EMBEDDED_CONFIG,
	'task-issue-embedded': TASK_ISSUE_EMBEDDED_CONFIG,
	'task-license-embedded': TASK_LICENSE_EMBEDDED_CONFIG,
	'task-opportunity-embedded': TASK_OPPORTUNITY_EMBEDDED_CONFIG,
	'task-sourcing-request-embedded': TASK_SOURCING_REQUEST_EMBEDDED_CONFIG,
	'competitive-price-client-embedded': COMPETITIVE_PRICE_CLIENT_EMBEDDED_CONFIG,
	'competitive-price-item-embedded': COMPETITIVE_PRICE_ITEM_EMBEDDED_CONFIG,
	'price-contract-client-embedded': PRICE_CONTRACT_CLIENT_EMBEDDED_CONFIG,
	'price-contract-item-embedded': PRICE_CONTRACT_ITEM_EMBEDDED_CONFIG,
	'automation-target-lists-embedded': AUTOMATION_TARGET_LISTS_EMBEDDED_CONFIG,
} as const;

/**
 * Type for the listBuilderDefaults keys
 */
export type ListBuilderDefaultsKey = keyof typeof listBuilderDefaults;

/**
 * Get list builder configuration by listKey.
 * Handles the hyphen-to-underscore conversion for embedded list keys.
 *
 * @param listKey - The list key (e.g., 'client', 'order-invoice-embedded')
 * @returns The list configuration or undefined if not found
 */
export function getListBuilderConfig(
	listKey: string,
): (typeof listBuilderDefaults)[ListBuilderDefaultsKey] | undefined {
	// First try the key as-is (handles keys with hyphens like 'group-users')
	if (listKey in listBuilderDefaults) {
		return listBuilderDefaults[listKey as ListBuilderDefaultsKey];
	}

	// Fall back to converting hyphens to underscores for legacy compatibility
	const normalizedKey = listKey.replace(/-/g, '_') as ListBuilderDefaultsKey;

	return listBuilderDefaults[normalizedKey];
}

/**
 * Interface for list configuration defaults structure
 */
interface ListConfigDefaults {
	lists?: Array<{ id: string }>;
}

/**
 * Validate that all listIds are unique across all list configurations.
 * Throws an error at build/import time if duplicates are found.
 *
 * This follows the same pattern as the filter registry's mergeWithDuplicateCheck.
 */
function validateUniqueListIds(
	defaults: Record<string, ListConfigDefaults>,
): void {
	const seenIds = new Map<string, string>(); // listId -> objectType

	for (const [objectType, config] of Object.entries(defaults)) {
		if (config.lists == null) {
			continue;
		}

		for (const list of config.lists) {
			if (list.id == null) {
				continue;
			}

			const existingObjectType = seenIds.get(list.id);

			if (existingObjectType != null) {
				throw new Error(
					`Duplicate listId detected: "${list.id}" exists in both "${existingObjectType}" and "${objectType}". ` +
						`Each list must have a globally unique ID.`,
				);
			}

			seenIds.set(list.id, objectType);
		}
	}
}

// Validate at module load time (will throw during build if duplicates exist)
validateUniqueListIds(
	listBuilderDefaults as Record<string, ListConfigDefaults>,
);
